import { Link } from "react-router-dom";

export const Logo = ({ to = "/", size = "md", className = "" }) => {
  const sizes = {
    sm: "text-lg",
    md: "text-xl",
    lg: "text-2xl",
  };
  return (
    <Link
      to={to}
      data-testid="logo-link"
      className={`inline-flex items-center gap-2 group ${className}`}
    >
      <span
        className="inline-flex items-center justify-center w-9 h-9 rounded-full shadow-sm"
        style={{ background: "var(--ta-primary)" }}
        aria-hidden
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 13.5L10 19L20 6"
            stroke="#F9F8F6"
            strokeWidth="2.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
      <span
        className={`font-display font-semibold ${sizes[size]} tracking-tight`}
        style={{ color: "var(--ta-primary)" }}
      >
        Your Monday Brief
      </span>
    </Link>
  );
};

export default Logo;
